import { useIcon } from '../../hooks/useIcons.jsx'

const Icon = ({ name, size = 24, className = "", ...props }) => {
  const IconComponent = useIcon(name)
  return <IconComponent size={size} className={className} {...props} />
}

export default Icon